module.exports = __webpack_public_path__ + "media/images/switch-on-cc57316b133d0cf439dd1445212d02e2.svg";